// extracted by mini-css-extract-plugin
export var cardLayout = "_6b-1";
export var paginationContainer = "_6b-0";